import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';

// eslint-disable-next-line import/prefer-default-export
export const BenefitsContainer = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 75px 0;

  img {
    width: 50px;
    height: 50px;
    object-fit: contain;
  }

  @media ${device.laptop} {
    align-items: flex-start;
    flex-direction: row;

    .benefit__sized {
      width: 25%;
      margin-right: 75px;
    }

    .benefit__sized:last-child {
      margin-right: 0;
    }
  }
`;
